// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__16XvC","inputWrap":"CustomTip_inputWrap__FbIeS"};